import React from 'react'

function MappedDevicesTable({ data }) {
    return (
        <>
            <div>
                <div className={`min-w-full ${data ? 'w-max' : 'flex-1'} rounded-lg flex justify-center py-2`}>
                    <table className="w-full mx-2 overflow-scroll relative">
                        <thead className="sticky top-0 bg-white z-10">
                            <tr>
                                <th>Devices</th>
                                <th>Brand</th>
                                <th>Model</th>
                                <th>Connectivity</th>
                                <th>Issued Date</th>
                                <th>Demo Given</th>
                            </tr>
                            <tr className="bg-[#DEF3F2]">
                                <td className="py-0.5" colSpan={12}></td>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {data?.map((item, idx) => (
                                <React.Fragment key={item.key || idx}>
                                    <tr>
                                        <td>{item.deviceName || item.name}</td>
                                        <td>{item.deviceBrand || item.brand}</td>
                                        <td>{item.deviceModel || item.model}</td>
                                        <td>{item.connectivity}</td>
                                        <td>{item.deliveredOn}</td>
                                        <td>{item.deviceDemo}</td>
                                    </tr>
                                    <tr className="bg-[#DEF3F2]">
                                        <td className="py-0.5" colSpan={12}></td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default MappedDevicesTable